var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 178,
    viewBox: "0 0 178 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89 0C138.15 0 178 39.8501 178 89C178 138.15 138.15 178 89 178C39.8501 178 0 138.15 0 89C0 39.8501 39.8501 0 89 0ZM120.68 94.5046C125.214 91.5784 125.2 88.3192 120.68 85.7262L73.848 58.8118C70.1541 56.4941 66.3009 57.8558 66.4023 62.6795L66.5472 117.073C66.8659 122.303 69.8499 123.737 74.2536 121.318L120.68 94.5046ZM89 18.0781C128.169 18.0781 159.922 49.8307 159.922 89C159.922 128.169 128.169 159.922 89 159.922C49.8307 159.922 18.0781 128.169 18.0781 89C18.0781 49.8307 49.8307 18.0781 89 18.0781Z",
    fill: "#E9EDF5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.0c27a47c138e3e29be55e9bed3edcf6a.svg";
export { ForwardRef as ReactComponent };